import React, {FC} from "react";
import {Box, Typography, styled} from "@mui/material";
import Badge, {BadgeProps} from "@mui/material/Badge";
import Fab from "@mui/material/Fab";
import ChevronLeftOutlined from "@mui/icons-material/ChevronLeftOutlined";
import ChevronRightOutlined from "@mui/icons-material/ChevronRightOutlined";
import {makeStyles} from "tss-react/mui";
import {palette} from "@/constants";

interface IProps {
	title?: React.ReactNode;
	badgeContent?: number | undefined;
	onScrollLeft: () => void;
	onScrollRight: () => void;
	canScrollLeft: boolean;
	canScrollRight: boolean;
}

const useStyles = makeStyles()((theme) => ({
	title: {
		color: theme.palette.text.primary,
		fontSize: "24px",
		fontWeight: 400
	},
	fab: {
		backgroundColor: "transparent",
		border: `1px solid ${theme.palette.action.active}`,
		color: theme.palette.action.active,
		width: "40px",
		height: "40px",
		"&:hover": {
			backgroundColor: theme.palette.grey[200]
		},
		"&.Mui-disabled": {
			backgroundColor: "transparent",
			border: `1px solid ${palette.grey08}`,
			color: theme.palette.action.active,
			opacity: 1, // prevents default MUI fade
			cursor: "not-allowed"
		}
	}
}));

export const StyledBadge = styled(Badge)<BadgeProps>(({theme}) => ({
	"& .MuiBadge-badge": {
		right: "-20px",
		top: "-3px",
		border: `1px solid ${(theme.vars ?? theme).palette.primary.main}`,
		color: (theme.vars ?? theme).palette.text.primary
	}
}));

export const SectionHeader: FC<IProps> = ({
	title,
	badgeContent,
	onScrollLeft,
	onScrollRight,
	canScrollLeft,
	canScrollRight
}) => {
	const {classes} = useStyles();
	return (
		<Box flexDirection={"row"} display="flex" alignItems="center" marginBottom={"6px"}>
			<Typography variant="h5" className={classes.title}>
				{title}
			</Typography>
			<StyledBadge badgeContent={badgeContent} max={Infinity} />
			<Box gap={1} display="flex" marginLeft="auto">
				<Fab className={classes.fab} onClick={onScrollLeft} disabled={!canScrollLeft}>
					<ChevronLeftOutlined />
				</Fab>
				<Fab className={classes.fab} onClick={onScrollRight} disabled={!canScrollRight}>
					<ChevronRightOutlined />
				</Fab>
			</Box>
		</Box>
	);
};

export default SectionHeader;

